import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'mage-react-router';
import classNames from 'classnames';
import * as sdf from '@SDFoundation';

class Breadcrumb extends React.Component {
  render() {
    const { paths } = this.props;

    return (
      <ul className={classNames('breadcrumb', sdf.bodyPrimary)}>
        {paths.map((path, idx) => (
          <li key={`bc-${idx}`}>
            {idx !== paths.length - 1 ? (
              <Link className="link" to={path.url}>
                {path.name}
              </Link>
            ) : (
              path.name
            )}
          </li>
        ))}
      </ul>
    );
  }
}

Breadcrumb.propTypes = {
  paths: PropTypes.array,
};

export default Breadcrumb;
